import { memo } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { ListingHeaderImage } from "app/pages/.shared/ListingHeaderImage";
import { merchandisingShape, resolutionPropType } from "app/utils/propTypes";
import Merchandising from "app/pages/Listing/merchandising/Merchandising";
import MerchandisingCarousel from "@brand/MerchandisingCarousel/MerchandisingCarousel";
import "./HeroMerch.scss";
import isEqual from "lodash/isEqual";

const HeroMerch = ({ merchList, resolution }) => {
	const noMerch = merchList.length === 0;
	const onlyOneMerch = merchList.length === 1;
	const firstMerch = get(merchList, "[0]");

	if (noMerch) {
		return null;
	}
	if (onlyOneMerch && firstMerch) {
		return (
			<div className="hero-merch" data-testid="hero-merch">
				<div className="hero-merch__container">
					<Merchandising
						imageElement={
							<ListingHeaderImage
								imgSrc={{
									desktop: {
										src: get(firstMerch, "photoLarge.url"),
										thumbnail: get(firstMerch, "photoLarge.thumbnail"),
									},
									mobile: {
										src: get(firstMerch, "photoSmall.url"),
										thumbnail: get(firstMerch, "photoSmall.thumbnail"),
									},
								}}
								resolution={resolution}
							/>
						}
						position={firstMerch.position}
						indexCarousel={firstMerch.headerIndex}
						ctaButtonText={get(firstMerch, "button.label")}
						ctaButtonBackgroundColor={get(firstMerch, "button.backgroundColor")}
						ctaButtonColor={get(firstMerch, "button.color")}
						merchandisingCode={firstMerch.code}
						endAt={firstMerch.endAt}
						countdownPosition={get(firstMerch, "countdown.position")}
						countdownTextColor={get(firstMerch, "countdown.textColor")}
						countdownStartAt={get(firstMerch, "countdown.startAt")}
						countdownEndAt={get(firstMerch, "countdown.endAt")}
						daysInHours={get(firstMerch, "countdown.daysInHours")}
						redirectUrl={get(firstMerch, "redirectUrl")}
					/>
				</div>
			</div>
		);
	}

	return (
		<div className="hero-merch hero-merch--multiple" data-testid="hero-merch">
			<div className="hero-merch__container">
				<MerchandisingCarousel merchandisingList={merchList} resolution={resolution} />
			</div>
		</div>
	);
};

HeroMerch.defaultProps = {
	merchList: [],
};

HeroMerch.propTypes = {
	resolution: resolutionPropType,
	merchList: PropTypes.arrayOf(merchandisingShape),
};

export default memo(HeroMerch, (prevProps, nextProps) => {
	return (
		isEqual(prevProps.merchList, nextProps.merchList) &&
		prevProps.resolution === nextProps.resolution
	);
});
